(function(){
  function reveal(root){
    var els=(root||document).querySelectorAll('.h1-reveal:not(.is-in)');
    if(!('IntersectionObserver' in window)){els.forEach(function(e){e.classList.add('is-in')});return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){if(x.isIntersecting){x.target.classList.add('is-in');io.unobserve(x.target);}})},{rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e)});
  }
  function ambient(root){
    var vids=(root||document).querySelectorAll('.h1-amb video');
    if(!vids.length) return;
    var reduce=window.matchMedia&&window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if(!('IntersectionObserver' in window)||reduce){return;}
    var io=new IntersectionObserver(function(en){en.forEach(function(x){var v=x.target;v.muted=true;if(x.isIntersecting){var p=v.play();if(p&&p.catch)p.catch(function(){});}else{v.pause();}})},{threshold:.25});
    vids.forEach(function(v){v.muted=true;v.setAttribute('muted','');io.observe(v)});
  }
  function players(){
    document.addEventListener('click',function(e){
      var btn=e.target.closest('[data-h1-play] .h1-play__btn'); if(!btn) return;
      var wrap=btn.closest('[data-h1-play]'); var tpl=wrap.querySelector('template'); if(!tpl) return;
      wrap.innerHTML=tpl.innerHTML; wrap.classList.add('is-playing');
      var v=wrap.querySelector('video'); if(v){var p=v.play();if(p&&p.catch)p.catch(function(){});}
    });
  }
  function scrollLinks(){
    document.addEventListener('click',function(e){
      var a=e.target.closest('a[href^="#"]'); if(!a) return;
      var id=a.getAttribute('href'); if(id.length<2) return;
      var t=document.querySelector(id); if(!t) return;
      e.preventDefault(); var y=t.getBoundingClientRect().top+window.pageYOffset-70;
      window.scrollTo({top:y,behavior:'smooth'});
    });
  }
  document.addEventListener('DOMContentLoaded',function(){reveal();ambient();players();scrollLinks();});
  document.addEventListener('shopify:section:load',function(e){reveal(e.target);ambient(e.target)});
  window.HIS1={reveal:reveal,ambient:ambient};
})();
